import {
    request,
    requestPublic
} from './request.js'

// 获取广告图列表
export function GetList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/Banner/GetList',
        method: 'get',
        params: {
            Page: 1,
            PageSize: 100,
            Name: obj.name,
            BannerPositionClass: obj.Type
        }
    })
}


// 获取详情
export function GetDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Banner/Get',
        method: 'get',
        params: {
            id: id
        }
    })
}

// 添加
export function Add(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Banner/Add',
        method: 'post',
        data:data
    })
}

// 编辑
export function Edit(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Banner/Edit',
        method: 'post',
        data:data
    })
}

// 删除
export function Delete(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Banner/Delete',
        method: 'post',
        params: {
            id: id
        }
    })
}
// 广告图投放位置
export function AllBannerPositions() {
    return request({
        url: '/api2/ZsbSiteAdmin/Banner/AllBannerPositions',
        method: 'get',
       
    })
}